// Panoya kopyalama düğmesi — uç nokta adresi ve API anahtarı için.
//
// Ajan konfigürasyonuna elle yazılacak iki değer de uzun ve hatasız olmak
// zorunda (URL'in bir harfi eksikse paketler ölü mektuba düşer, anahtar bir kez
// gösterilir). Bu yüzden kopyalama ekranın ana eylemi.

import { useState } from 'react'
import { toast } from '../../components/Toast'

export default function Kopyala({
  metin,
  etiket,
  tam = false,
}: {
  metin: string
  /** Toast'ta ne kopyalandığını söyler — "yan etkiyi anlat" kuralı. */
  etiket: string
  /** Genişliği kaplasın mı (drawer içindeki tek düğme). */
  tam?: boolean
}) {
  const [kopyalandi, setKopyalandi] = useState(false)

  async function kopyala() {
    try {
      // navigator.clipboard yalnız güvenli bağlamda (https/localhost) var;
      // yoksa kullanıcıya "kopyaladım" demek yalan olurdu — hata metni
      // metni elle seçmesini söylüyor.
      await navigator.clipboard.writeText(metin)
      setKopyalandi(true)
      window.setTimeout(() => setKopyalandi(false), 1800)
      toast(`${etiket} panoya kopyalandı`)
    } catch {
      toast('Pano erişimi yok — metni elle seçip kopyalayın')
    }
  }

  return (
    <button
      className="btn btn-sec btn-sm"
      type="button"
      title={`${etiket} panoya kopyalanır`}
      style={tam ? { flex: 1, justifyContent: 'center' } : undefined}
      onClick={kopyala}
    >
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        {kopyalandi ? (
          <path d="m20 6-11 11-5-5" />
        ) : (
          <>
            <rect x="9" y="9" width="13" height="13" rx="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </>
        )}
      </svg>
      {kopyalandi ? 'Kopyalandı' : 'Kopyala'}
    </button>
  )
}

/**
 * Aynı işin ikon boyu — tablo satırında metnin yanında duracak kadar küçük.
 * Ayrı bileşen çünkü tablo hücresinde "Kopyala" yazısı satırı taşırıyor.
 */
export function KopyaMini({
  metin,
  etiket,
  kapali,
  ipucu,
}: {
  metin: string
  etiket: string
  /** Kopyalanacak değer henüz yoksa (ör. anahtar gizli) düğme pasif. */
  kapali?: boolean
  ipucu?: string
}) {
  const [kopyalandi, setKopyalandi] = useState(false)

  return (
    <button
      className="mini-btn"
      type="button"
      disabled={kapali}
      title={ipucu ?? `${etiket} panoya kopyalanır`}
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(metin)
          setKopyalandi(true)
          window.setTimeout(() => setKopyalandi(false), 1800)
          toast(`${etiket} panoya kopyalandı`)
        } catch {
          toast('Pano erişimi yok — metni elle seçip kopyalayın')
        }
      }}
    >
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        {kopyalandi ? (
          <path d="m20 6-11 11-5-5" />
        ) : (
          <>
            <rect x="9" y="9" width="13" height="13" rx="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </>
        )}
      </svg>
    </button>
  )
}
